// AUTO-GENERATED by `npm run codegen:ui` - do not edit.
namespace $ {

export type easyreels_user_recorder_ticketsMutationVariables = Exact<{
  input: RequestUploadURLsInput;
}>;


export type easyreels_user_recorder_ticketsMutation = { __typename?: 'Mutation', requestUploadURLs: { __typename: 'ErrorPayload', message: string } | { __typename: 'QuotaExceededPayload', message: string, usedBytes: number, limitBytes: number } | { __typename: 'RequestUploadURLsPayload', tickets: Array<{ __typename?: 'UploadTicket', sequence: number, url: string, fields: Array<{ __typename?: 'FormField', name: string, value: string }>, expiresAt: { __typename?: 'Timestamp', unix: number } }> } };


export function $easyreels_user_recorder_tickets(variables: easyreels_user_recorder_ticketsMutationVariables, opts?: { revalidate?: boolean }): easyreels_user_recorder_ticketsMutation {
	return $easyreels_gql_user_request(`mutation easyreels_user_recorder_tickets(\u0024input: RequestUploadURLsInput!) {
  requestUploadURLs(input: \u0024input) {
    __typename
    ... on RequestUploadURLsPayload {
      tickets {
        sequence
        url
        fields {
          name
          value
        }
        expiresAt {
          unix
        }
      }
    }
    ... on QuotaExceededPayload {
      message
      usedBytes
      limitBytes
    }
    ... on ErrorPayload {
      message
    }
  }
}`, variables, opts) as easyreels_user_recorder_ticketsMutation
}

}
